import type { Extension } from '@atlassian/forge-ui';
import { ExtensionEnvironment } from '@atlassian/forge-ui-types';

export const transformPreFilteredExtensions = (extensions) => {
	return (extensions || []).flatMap((extension): Extension[] => {
		if (!extension) {
			return [];
		}

		if (!extension.environmentKey) {
			return [];
		}

		return [
			{
				id: extension.id,
				appId: extension.appId,
				key: extension.key,
				environmentId: extension.environmentId,
				environmentType:
					extension.environmentType === ExtensionEnvironment.DEVELOPMENT ||
					extension.environmentType === ExtensionEnvironment.STAGING ||
					extension.environmentType === ExtensionEnvironment.PRODUCTION
						? extension.environmentType
						: ExtensionEnvironment.DEVELOPMENT,
				environmentKey: extension.environmentKey,
				properties: extension.properties.reduce((acc, property) => {
					if (!property.value || !property.key) {
						return acc;
					}

					try {
						const jsonValue = JSON.parse(property.value);
						acc[property.key] = jsonValue;
					} catch (error) {
						acc[property.key] = property.value;
					}
					return acc;
				}, {}),
				license: extension.license
					? {
							...extension.license,
							//@ts-ignore capabilitySet mapped to valid value
							capabilitySet:
								extension.license.capabilitySet === 'CAPABILITY_ADVANCED'
									? 'capabilityAdvanced'
									: 'capabilityStandard',
						}
					: null,
				userAccess: extension.userAccess
					? {
							hasAccess: extension.userAccess.hasAccess ?? false,
							enabled: extension.userAccess.enabled ?? false,
						}
					: null,
				type: extension.type,
				installationId: extension.installationId,
				appVersion: extension.appVersion ?? undefined,
				consentUrl: extension.consentUrl ?? undefined,
				migrationKey: extension.migrationKey ?? undefined,
				egress:
					extension.egress?.flatMap((egress) => {
						if (!egress.type || !egress.addresses) {
							return [];
						}

						return [
							{
								type: egress.type,
								addresses: egress.addresses?.flatMap((address) => address ?? []),
								category: egress.category ?? undefined,
								inScopeEUD: egress.inScopeEUD ?? undefined,
							},
						];
					}) ?? undefined,
				scopes: extension.scopes ?? undefined,
				installationConfig:
					extension.installationConfig?.flatMap((config) => {
						if (!config?.key || config.value === null) {
							return [];
						}

						return [
							{
								key: config.key,
								value: config.value,
							},
						];
					}) ?? undefined,
				dataClassificationPolicyDecision: {
					status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED',
				},
			},
		];
	});
};
